module.exports = __webpack_public_path__ + "static/media/AboutPage2Img3.d56438df.png";